import http from '../../store/services/http-common';
import { getJwtToken, isAuthenticated } from '../../utilities/authentication';
import { dedupeRequest } from '../requestDeduper';
import { queryKeys } from '../queryKeys';
import { queryClient } from '../queryClient';

/**
 * Current authenticated vendor user (permissions, pages, client linkage).
 * Shared via React Query so Strict Mode remounts and layout revisits do not
 * re-hit GET /me while the session cache is fresh.
 */
export async function fetchCurrentUser() {
  if (!isAuthenticated()) {
    throw new Error('Not authenticated');
  }

  return dedupeRequest(queryKeys.vendor.me().join(':'), async () => {
    const response = await http.get('/me');
    return response?.data?.user ?? null;
  });
}

export function meQueryOptions() {
  return {
    queryKey: queryKeys.vendor.me(),
    queryFn: fetchCurrentUser,
    staleTime: 5 * 60 * 1000,
    gcTime: 15 * 60 * 1000,
    enabled: Boolean(getJwtToken()),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    retry: 1,
  };
}

export function invalidateCurrentUser() {
  return queryClient.invalidateQueries({ queryKey: queryKeys.vendor.me() });
}
